import styled from 'astroturf/react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const fontSizeTitleLarge = 'var(--fontSizeTitleLarge, 1.375rem)'
const spaceXSmall = 'var(--spacing-0-25x, 0.25rem)'
import { Loader } from '@calendly/ui/components/loader'
import { useFlag } from '@calendly/feature-check-react'

import { useI18n } from 'locales'
import CircleCheck from 'components/confirmation/circle-check.svg'
import { GmailConfirmation } from 'components/confirmation/gmail_confirmation'
import PaymentMessage from 'components/confirmation/pages/new_confirmation/payment_message'
import ErrorAlert from 'components/error/alert'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import _Header from "Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=Header";
import _TitleLine from "header-TitleLine.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=TitleLine";
import _PaymentMessageWrapper from "header-PaymentMessageWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=PaymentMessageWrapper";
import _Icon from "header-Icon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/header.js?styleId=Icon";


const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const TitleLine = /*#__PURE__*/styled('h2', null, {
  displayName: "TitleLine",
  styles: _TitleLine
})

const PaymentMessageWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentMessageWrapper",
  styles: _PaymentMessageWrapper
})

const Icon = /*#__PURE__*/styled('img', null, {
  displayName: "Icon",
  styles: _Icon
})

export const PersonalizedHeader = () => {
  const { event } = useConfirmationPageData()
  const { isReschedulingFlow, fullName, shouldSeeGmailSniperLink } = useConfirmationPageData()
  const { i18n } = useI18n()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  const titleText = fullName
    ? i18n.t(
      isReschedulingFlow
        ? 'booking.templates.rescheduled_personalized'
        : 'booking.templates.scheduled_personalized',
      { name: fullName }
    )
    : i18n.t(
      isReschedulingFlow
        ? 'booking.templates.rescheduled'
        : 'booking.templates.scheduled'
    )

  if (event === undefined) return <Loader />
  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  return (
    <Header bookingAppRedesign={bookingAppRedesign} data-component="confirmation-header">
      {!bookingAppRedesign && <Icon src={CircleCheck} alt="" />}
      <TitleLine bookingAppRedesign={bookingAppRedesign}>
        {titleText}
      </TitleLine>
      <PaymentMessageWrapper bookingAppRedesign={bookingAppRedesign}>
        <PaymentMessage />
      </PaymentMessageWrapper>
      {shouldSeeGmailSniperLink && <GmailConfirmation />}
    </Header>
  )
}
